module.exports = __webpack_public_path__ + "img/sFruitTyc_350x350.998ba82f.jpg";